import NavLink from 'rev.sdk.js/Components/NavLink';

export default NavLink;
